import { useTranslation } from 'react-i18next'
import { HeroSection } from '@/components/sections/HeroSection'
import { ExperienceSection } from '@/components/sections/ExperienceSection'
import { SectorsGridSection } from '@/components/sections/SectorsGridSection'
import { ProcessSteps } from '@/components/sections/ProcessSteps'
import { PartnershipsSection } from '@/components/sections/PartnershipsSection'
import { NewsletterSection } from '@/components/sections/NewsletterSection'
import { CTASection } from '@/components/sections/CTASection'
import { PageMeta } from '@/components/PageMeta'

export function HomePage() {
  const { t } = useTranslation()
  return (
    <>
      <PageMeta title={t('company.name')} description={t('company.tagline')} />
      <HeroSection />
      <ExperienceSection />
      <SectorsGridSection />
      <ProcessSteps />
      <NewsletterSection />
      <PartnershipsSection />
      <CTASection />
    </>
  )
}
